import { keyBy } from 'es-toolkit';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TruckDriver } from '@paragon/contract-library';

interface TruckDriversState {
  status: 'loading' | 'loaded' | 'catastrophicallyFailed';

  truckDrivers: Record<string, TruckDriver>;
}

const initialState: TruckDriversState = {
  status: 'loading',
  truckDrivers: {},
};

export const truckDriversSlice = createSlice({
  name: 'truckDrivers',
  initialState,
  reducers: {
    loadedFromServer(state, action: PayloadAction<readonly TruckDriver[]>) {
      state.status = 'loaded';
      state.truckDrivers = keyBy(action.payload, (truckDriver) => truckDriver.guid);
    },

    loadingCatastrophicallyFailed(state) {
      state.status = 'catastrophicallyFailed';
    },

    truckDriverCreated(state, action: PayloadAction<TruckDriver>) {
      state.truckDrivers[action.payload.guid] = action.payload;
    },

    truckDriverArchivedStatusSet(state, action: PayloadAction<{ guid: string; archived: boolean }>) {
      const { guid, archived } = action.payload;
      state.truckDrivers[guid].archived = archived;
    },
  },
});
